import { render, staticRenderFns } from "./HomeActiveMenu.vue?vue&type=template&id=0d077a08&scoped=true&"
import script from "./HomeActiveMenu.vue?vue&type=script&lang=js&"
export * from "./HomeActiveMenu.vue?vue&type=script&lang=js&"
import style0 from "./HomeActiveMenu.vue?vue&type=style&index=0&id=0d077a08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d077a08",
  null
  
)

export default component.exports